import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Youtube, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0a0a0a] border-t border-white/10 mt-0">
      <div className="px-6 md:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="https://customer-assets.emergentagent.com/job_wrestling-federation/artifacts/traed3wv_Yellow%20Logo.png" alt="CWF" className="h-14 w-auto" />
            <span className="font-display text-2xl tracking-wide">Championship Wrestling Federation</span>
          </div>
          <p className="font-display text-2xl text-brand uppercase tracking-wide mb-3">Built for the fans. Powered by the community.</p>
          <p className="text-zinc-500 max-w-md leading-relaxed">
            Tyler, Texas' own CWF brings wrestling fans together with action-packed, family-friendly events. More than a show — we're a community.
          </p>
          <div className="flex gap-4 mt-6">
            {[
              { Icon: Facebook, url: "https://facebook.com/watchcwf" },
              { Icon: Twitter, url: "https://x.com/watchcwf" },
              { Icon: Youtube, url: "https://youtube.com/@watchcwf" },
            ].map(({ Icon, url }, i) => (
              <a key={i} href={url} target="_blank" rel="noreferrer" data-testid={`footer-social-${i}`} className="w-10 h-10 border border-zinc-700 flex items-center justify-center text-zinc-400 hover:border-brand hover:text-brand transition-colors">
                <Icon size={18} />
              </a>
            ))}
          </div>
          <p className="font-mono text-xs uppercase tracking-widest text-zinc-600 mt-4">Follow us @watchcwf</p>
        </div>
        <div>
          <h4 className="font-display text-xl uppercase tracking-wide mb-4 text-white">Explore</h4>
          <ul className="space-y-2 text-zinc-500">
            <li><Link to="/roster" className="hover:text-brand">Roster</Link></li>
            <li><Link to="/events" className="hover:text-brand">Events</Link></li>
            <li><Link to="/championships" className="hover:text-brand">Champions</Link></li>
            <li><Link to="/news" className="hover:text-brand">News</Link></li>
          </ul>
        </div>
        <div>
          <ul className="space-y-2 text-zinc-500 mt-11">
            <li><Link to="/gallery" className="hover:text-brand">Gallery</Link></li>
            <li><Link to="/media" className="hover:text-brand">Media</Link></li>
            <li><Link to="/sponsors" className="hover:text-brand">Sponsors</Link></li>
            <li><a href="mailto:watchcwf@gmail.com?subject=General%20Inquiry" data-testid="footer-contact-link" className="hover:text-brand">Contact</a></li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-brand">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 md:px-12 lg:px-20 py-6 text-zinc-600 text-sm">
        <span>© {new Date().getFullYear()} Championship Wrestling Federation, LLC. All rights reserved.</span>
      </div>
    </footer>
  );
}
